import React, { createContext, useContext } from "react";
import { useToast, type ToastType, type Toast, type ErrorModal } from "../hooks/useToast";
import ToastContainer from "../components/ToastContainer";
import ErrorModal from "../components/ErrorModal";

interface ToastContextType {
  toasts: Toast[];
  error: (message: string) => string;
  success: (message: string) => string;
  warning: (message: string) => string;
  info: (message: string) => string;
  addToast: (message: string, type?: ToastType) => string;
  removeToast: (id: string) => void;
  errorModal: ErrorModal;
  closeErrorModal: () => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const { toasts, error, success, warning, info, addToast, removeToast, errorModal, closeErrorModal } = useToast();

  return (
    <ToastContext.Provider value={{ toasts, error, success, warning, info, addToast, removeToast, errorModal, closeErrorModal }}>
      {children}
      <ToastContainer toasts={toasts} onClose={removeToast} />
      <ErrorModal open={errorModal.open} message={errorModal.message} onClose={closeErrorModal} />
    </ToastContext.Provider>
  );
}

export function useToastContext() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToastContext must be used within ToastProvider");
  }
  return context;
}
